/** @format */
import { ImageWithCaption } from '@mpb-com/feather/components/atoms/image-with-caption';
import React from 'react';

import { ContentfulCaption } from '@toucan/client/features/contentful/components/caption';
import { ContentfulPicture } from '@toucan/client/features/contentful/components/picture';

import { ContentfulImageWithCaptionProps } from './type';

export const ContentfulImageWithCaption = ({
    image,
    caption,
    size,
}: ContentfulImageWithCaptionProps) => {
    if (!image) {
        return null;
    }

    return (
        <ImageWithCaption
            className="image-with-caption"
            caption={<ContentfulCaption caption={caption} />}
            image={<ContentfulPicture image={image} />}
            size={size ?? undefined}
        />
    );
};
